export interface TickerItem {
  id: number;
  kind: string;
  text: string;
  time: string;
}

export interface EntryGroup {
  icon: string;
  label: string;
  count: string;
}

export interface LeadPost {
  image: string;
  title: string;
  summary: string;
  kind: string;
  source: string;
  comments: string;
}

export interface FeedPost {
  id: number;
  kind: string;
  title: string;
  excerpt: string;
  source: string;
  time: string;
  comments: string;
  image?: string;
}

export interface CompareRow {
  id: number;
  type: '辟谣' | '实锤' | '待核实';
  rumor: string;
  fact: string;
  source: string;
}

export interface CollectionCard {
  title: string;
  count: string;
  desc: string;
  image: string;
}

export interface RankItem {
  title: string;
  heat: string;
  trend: 'up' | 'down' | 'flat';
  kind: string;
}

export interface TimelineStep {
  time: string;
  text: string;
  tag: string;
}

export interface DiscussionPost {
  author: string;
  time: string;
  text: string;
  agree: string;
  total: string;
  tag: string;
}

export const topTicker: TickerItem[] = [
  { id: 1, kind: '新进展', text: '第 108 期追踪：某头部带货主播离职录音核查有新节点，当事人团队发声明称系断章取义', time: '刚刚' },
  { id: 2, kind: '辟谣', text: '网传"某某塌房实锤照"经查系旧图复用，已实锤反转', time: '8 分钟前' },
  { id: 3, kind: '反转', text: '"迟到未播女主播被雪藏"后续：官方称是档期调整，非封杀', time: '21 分钟前' },
  { id: 4, kind: '当事人回应', text: '人气主播阿澄就"嘴瓢争议"发文澄清，附完整录屏自证', time: '36 分钟前' },
  { id: 5, kind: '待核实', text: '"某公会内斗黑料清单"在流传，目前暂未找到可靠信源，理性看待', time: '1 小时前' },
  { id: 6, kind: '实锤', text: '带货商家晒出官方质检报告，此前"假货传闻"正式告一段落', time: '2 小时前' },
];

export const entryGroups: EntryGroup[] = [
  { icon: 'ri-refresh-line', label: '反转榜', count: '本周 38 条' },
  { icon: 'ri-file-shield-2-line', label: '辟谣档案', count: '已澄清 126 篇' },
  { icon: 'ri-check-double-line', label: '实锤对照', count: '有据 74 起' },
  { icon: 'ri-megaphone-line', label: '当事人回应', count: '回应合集 52 期' },
  { icon: 'ri-time-line', label: '事件时间线', count: '追踪 29 个' },
  { icon: 'ri-folder-open-line', label: '往期合集', count: '归档 96 期' },
];

export const leadPost: LeadPost = {
  image: 'https://readdy.ai/api/search-image?query=flat%20minimal%20editorial%20illustration%20on%20warm%20cream%20paper%20background%20of%20a%20megaphone%20with%20stacked%20documents%20and%20a%20red%20vermillion%20rubber%20stamp%20showing%20approval%20mark%20and%20ink%20brush%20strokes%20around%20amber%20accents%20thin%20black%20outlines%20modern%20vector%20no%20text%20no%20letters%20no%20words&width=1200&height=675&seq=lead-reversal-01&orientation=landscape',
  title: '今日风向反转：被传"离职内幕"的主播，官方终于晒出关键证据',
  summary: '从截图到录音，这轮传闻经历了辟谣、二次发酵到当事人团队补充回应。我们把时间线、原始说法与最新证据摊开对照，到底哪一环才是被忽略的真相。',
  kind: '反转',
  source: '独家追踪',
  comments: '1.2 万讨论',
};

export const feedPosts: FeedPost[] = [
  {
    id: 1,
    kind: '反转',
    title: '"被封杀 3 年"再度登热搜，主播本人直播回应：账号一直在正常更新',
    excerpt: '一则旧闻被反复加工成"新瓜"，当事人直接用后台数据与直播画面回应，热度反转明显，评论区风向已明显转向。',
    source: '当事人回应',
    time: '32 分钟前',
    comments: '8.6 千',
    image: 'https://readdy.ai/api/search-image?query=flat%20minimal%20editorial%20illustration%20on%20cream%20paper%20of%20magnifying%20glass%20over%20torn%20newspaper%20pages%20and%20a%20thin%20red%20vermillion%20slash%20line%20indicating%20correction%20ink%20outline%20style%20no%20text%20no%20letters&width=720&height=470&seq=feed-reversal-01&orientation=landscape',
  },
  {
    id: 2,
    kind: '实锤',
    title: '商家晒平台审核记录，此前"成分造假"说法未获平台侧证实',
    excerpt: '店铺资质、批次报告与平台抽检记录一同放出，围观者直言"这次图个明白"。',
    source: '平台核实',
    time: '1 小时前',
    comments: '5.2 千',
  },
  {
    id: 3,
    kind: '辟谣',
    title: '辟谣帖：所谓"内部聊天记录"经查为合成拼接，多处时间戳对不上',
    excerpt: '技术流网友逐帧比对发现破绽，呼吁吃瓜先验原图。',
    source: '核查组',
    time: '2 小时前',
    comments: '3.9 千',
  },
  {
    id: 4,
    kind: '当事人回应',
    title: '新人主播发千字长文澄清：奖金分配截图被去头去尾，已请律师取证',
    excerpt: '回应发布两小时播放破百万，评论区两派观点胶着。',
    source: '当事人回应',
    time: '3 小时前',
    comments: '6.1 千',
  },
  {
    id: 5,
    kind: '实锤',
    title: '前合作方放出生意往来单据，此前"白嫖分成"说法获实物佐证',
    excerpt: '单据编号与平台后台一致，舆论从质疑转向追问后续。',
    source: '实锤对照',
    time: '4 小时前',
    comments: '4.4 千',
    image: 'https://readdy.ai/api/search-image?query=flat%20minimal%20editorial%20illustration%20of%20receipts%20and%20invoices%20paper%20stack%20with%20a%20red%20vermillion%20verified%20stamp%20and%20checkmark%20on%20warm%20cream%20paper%20ink%20outline%20no%20text%20no%20letters&width=720&height=470&seq=feed-fact-01&orientation=landscape',
  },
  {
    id: 6,
    kind: '待核实',
    title: '一份"公会深夜通告"流传中，多方信源目前说法不一，先观望',
    excerpt: '既无盖章原件也未见平台回应，建议等当事人或官方正式发声再下结论。',
    source: '信源核查',
    time: '5 小时前',
    comments: '1.8 千',
  },
  {
    id: 7,
    kind: '辟谣',
    title: '"年入千万被偷税"纯属误传：实际是 2018 年旧报道，与本人无关',
    excerpt: '标题党害人不浅，正文与配图都对不上号，已列入澄清归档。',
    source: '辟谣档案',
    time: '6 小时前',
    comments: '2.6 千',
  },
  {
    id: 8,
    kind: '反转',
    title: '吵了一天的"道歉视频"，原来是模仿秀博主整活，网友直呼被骗',
    excerpt: '当事人没塌，塌的是大家熬夜吃瓜的期待值。',
    source: '风向观察',
    time: '7 小时前',
    comments: '7.7 千',
  },
  {
    id: 9,
    kind: '实锤',
    title: '平台处理公告落地：涉事直播间封禁 7 天，处罚明细全程可查',
    excerpt: '从质疑到公告，这起事件的处理链条首次完整闭环。',
    source: '官方动态',
    time: '8 小时前',
    comments: '3.3 千',
  },
  {
    id: 10,
    kind: '当事人回应',
    title: '两位当事人隔空互辩后同框连麦，三小时直播把争议聊开了',
    excerpt: '没有剧本式的和解，只有不停被打断的对话，评论区却安静了。',
    source: '当事人回应',
    time: '9 小时前',
    comments: '9.2 千',
  },
];

export const compareData: CompareRow[] = [
  { id: 1, type: '实锤', rumor: '网传"该主播曾挪用公会资金"', fact: '查无挪用记录，但发现一笔代垫款未及时入账，属管理疏漏，已发公告致歉', source: '财务对账 + 公告' },
  { id: 2, type: '辟谣', rumor: '所谓"未婚先孕实锤图"疯传', fact: '原图系 2021 年剧照，人物并非本人，已实锤为旧图复用', source: '反向搜图比对' },
  { id: 3, type: '待核实', rumor: '"与大品牌解约因违约"尚无定论', fact: '双方均未正面回应，仅第三方称系正常合同到期，仍在核实中', source: '多方信源比对' },
  { id: 4, type: '实锤', rumor: '有商家吐槽"合作后失联"', fact: '当事人团队晒出全程沟通记录并完成退款，平台介入后账号已正常', source: '聊天记录 + 退款凭证' },
  { id: 5, type: '辟谣', rumor: '"学历造假退学"传闻热度高', fact: '校方证明文件显示确在读，网传退学截图经查系 P 图', source: '校方函询' },
  { id: 6, type: '待核实', rumor: '"粉丝刷量数据造假"说法在流传', fact: '数据平台显示增长曲线异常但无法判定人为，等待平台出具说明', source: '数据核查' },
];

export const collectionCards: CollectionCard[] = [
  { title: '头部主播翻车复盘', count: '24 篇追踪', desc: '从首爆到收尾的完整事件档案', image: 'https://readdy.ai/api/search-image?query=flat%20minimal%20editorial%20illustration%20of%20a%20small%20television%20screen%20with%20play%20button%20and%20document%20timeline%20marks%20on%20cream%20paper%20red%20vermillion%20and%20amber%20accents%20ink%20outline%20no%20text%20no%20letters&width=520&height=380&seq=collection-01&orientation=portrait' },
  { title: '带货售后争议合集', count: '31 起样本', desc: '退款、假货、成分三大高频争议查证', image: 'https://readdy.ai/api/search-image?query=flat%20minimal%20editorial%20illustration%20of%20shopping%20bags%20and%20boxes%20with%20a%20magnifying%20glass%20on%20cream%20paper%20with%20thin%20red%20and%20amber%20ink%20outlines%20no%20text%20no%20letters&width=520&height=380&seq=collection-02&orientation=portrait' },
  { title: '连线互怼现场还原', count: '18 场录播', desc: '谁在断章取义，谁在转移焦点，逐句复盘', image: 'https://readdy.ai/api/search-image?query=flat%20minimal%20editorial%20illustration%20of%20two%20speech%20bubbles%20facing%20each%20other%20with%20a%20recording%20microphone%20in%20middle%20on%20cream%20paper%20red%20amber%20ink%20outline%20no%20text%20no%20letters&width=520&height=380&seq=collection-03&orientation=portrait' },
  { title: '年度澄清红榜', count: '2026 上半年', desc: '被误解最深的当事人与最有力的自证', image: 'https://readdy.ai/api/search-image?query=flat%20minimal%20editorial%20illustration%20of%20a%20laurel%20trophy%20and%20ribbon%20on%20a%20sealed%20document%20on%20cream%20paper%20with%20red%20and%20amber%20ink%20outlines%20no%20text%20no%20letters&width=520&height=380&seq=collection-04&orientation=portrait' },
];

export const rankItems: RankItem[] = [
  { title: '离职内幕录音事件', heat: '842 万', trend: 'up', kind: '反转' },
  { title: '连麦互怼后同框和解', heat: '617 万', trend: 'up', kind: '新进展' },
  { title: '成分报告实锤打脸', heat: '503 万', trend: 'up', kind: '实锤' },
  { title: '"退学"造谣辟谣后致歉', heat: '366 万', trend: 'down', kind: '辟谣' },
  { title: '模仿秀乌龙道歉视频', heat: '291 万', trend: 'flat', kind: '反转' },
  { title: '公会通告待核实讨论', heat: '188 万', trend: 'down', kind: '待核实' },
];

export const caseInfo = {
  tag: '专题追踪',
  title: '「阿澄奖金争议」全时间线',
  lead: '从一张被截断的分成截图，到律师函，再到本人直播自证——这是本周讨论度最高的当事人回应事件，我们把每一步都摊在桌面上。',
  cover: 'https://readdy.ai/api/search-image?query=flat%20minimal%20editorial%20illustration%20of%20a%20horizontal%20timeline%20with%20numbered%20milestone%20dots%20connected%20by%20a%20thin%20line%20on%20cream%20paper%20with%20red%20vermillion%20and%20amber%20ink%20accents%20no%20text%20no%20letters%20no%20words&width=1280&height=720&seq=case-timeline-01&orientation=landscape',
  timeline: [
    { time: '周一 10:02', text: '一张"分成截图"在社群流传，标注为内部消息，引发首批转发。', tag: '首爆' },
    { time: '周一 20:40', text: '原图被指出疑似拼接，部分水印与字号异常，核查组标记为存疑。', tag: '存疑' },
    { time: '周二 09:15', text: '事件冲上热搜，当事人阿澄连发两条动态称截图"被去头去尾"。', tag: '回应' },
    { time: '周三 14:30', text: '团队晒出完整后台流水，并同步律师函取证说明，播放破百万。', tag: '自证' },
    { time: '周四 11:00', text: '原始发布者现身致歉，称"转发未核实"，事件热度开始回落。', tag: '收束' },
  ],
};

export const discussionPosts: DiscussionPost[] = [
  { author: '吃瓜要有依据', time: '12 分钟前', text: '截图能不能别一上来就信？至少要看看是不是旧图、有没有时间戳对得上。今天好几条都是这么翻车的。', agree: '2.1 千', total: '3.4 千', tag: '求实' },
  { author: '不站队只看料', time: '40 分钟前', text: '两边都在发证据，我选择再等等，等官方下场再下结论，最怕站队站早了被打脸。', agree: '1.6 千', total: '2.7 千', tag: '观望' },
  { author: '当事人看累了', time: '1 小时前', text: '其实最有说服力的不是长文，是那个三小时连麦，聊开了评论区就安静了，这个瓜吃得值。', agree: '3.0 千', total: '5.1 千', tag: '理性吃瓜' },
  { author: '反向去重小能手', time: '2 小时前', text: '帮大家贴一下那几张图的出处，全是两年前的旧图，拿去复用的朋友长点心。', agree: '986', total: '1.4 千', tag: '技术流' },
  { author: '楼下是我小号', time: '3 小时前', text: '建议官方能出一个"辟谣到实锤"的进度条，追起来真的省力，我反正是被绕晕过好几次。', agree: '2.4 千', total: '3.8 千', tag: '建议' },
];

export const trendTags: string[] = [
  '离职录音', '同框连麦', '成分报告', '退学造谣', '仿拍道歉', '公会通告',
  '分成截图', '旧图复用', '售后退款', '封禁公告', '翻车复盘', '年度澄清红榜',
];

export const hotRegions = {
  updated: '今日更新 23 期',
  online: '正在追踪 29 个事件',
  daily: '日均讨论帖 1.8 万+',
};